import React, { FC, useState } from "react";
import { Button, message, Table, Upload, Image } from "antd";
import { YhBox } from "@/components/YhBox";
import { ColumnsType } from "antd/es/table";
import { RouterParamType } from "@/model/navModel";
import { YhBut } from "@/components/YhButton";
import { formatNum } from "@/utils/utils";
import { EditableRow, EditableCell } from "@/components/YHEditTable/editTable";
import { useShipmentDetailModel } from "../shipmentDetailModel";
import { YhAuth } from "@/components/auth/YhAuth";
import { ResourceAuthEnum } from "@/types/AppResourceAuthEnum";
import { importPropsConfig } from "@/utils/importFile";
import { IShipmentDetailsAdded } from "@/views/shipment/shimentTypes";
import useGlobalModel from "@/model/globalModel";
import { publicService } from "@/views/public/publicService";
import { convertRes2Blob } from "@/utils/exportFile";
import { useDictModel } from "@/views/base/dict/dictModel";
import { getBaseRequestUrl, getToken } from "@/utils/constants";
import { DictCodeEnmu } from "@/types/AppDictEnums";

//加收费用
export const TableBoxAdded: FC<RouterParamType> = ({ id, mode }) => {
    const { editAddedList, setEditAddedList, addAdded, setSettleVisible, updateFormVal, clauseChange, isSave, setIsSave, getcurrencySymbol,editFormVal
    } = useShipmentDetailModel(({ editAddedList, isSave }) => [editAddedList, isSave]);
    const { supplierDs } = useGlobalModel(({ supplierDs }) => [supplierDs]);
    const [selectedRowKeys, setSelectedRowKeys] = useState<IShipmentDetailsAdded[]>([]);
    const { getTreeNodeName } = useDictModel(() => []);

    //下载文件
    const downloadFile = async (fileId?: string, fileName?: string) => {
        if (!fileId) return message.warning("文件异常，无法下载查看")
        //pdf开网页预览
        if (fileId.indexOf(".pdf") >= 0) {
            window.open(`${getBaseRequestUrl()}/fsrv/fetch/${fileId}?Authorization=${getToken()}`)
            return;
        }
        try {
            let result = await publicService.downloadFile(fileId);
            convertRes2Blob(result, fileName);
        } catch (error) {
            console.error(error)
        }
    }

    const columns = [
        {
            title: '操作',
            width: 80,
            fixed: "left",
            align: "center",
            className: "td-wrap",
            render: (text: any, record: any, i: number) =>
                record.key === "totalAmount" ?
                    "" : editFormVal.status !== 'shipment.bl'? <>
                        <YhBut
                            type="add"
                            txt="添加"
                            click={() => addAdded(mode)}
                        />
                        <YhBut
                            type="delete"
                            txt="删除"
                            disabled={editAddedList.length <= 1 || record.status === DictCodeEnmu.SHIPMENT_SETTLE}
                            click={() => {
                                setEditAddedList(origin => origin.filter(item => item.key !== record.key));
                                setSelectedRowKeys([])
                            }}
                        />
                    </> :""
        },
        {
            title: '序号',
            width: 50,
            align: "center",
            fixed: "left",
            dataIndex: "totalTxt",
            render: (t: any, r: any, i: number) => <>{t ? t : i + 1}</>
        }, {
            title: '供应商名称',
            width: 160,
            dataIndex: 'supplierCode',
            // editable: true,
            editable:editFormVal.status !== 'shipment.bl',
            editType: "select",
            options: supplierDs,
            render: (text: string) => <span className="pl-12">{supplierDs.find(item => item.value === text)?.label}</span>
        }, {
            title: '费用名称(英文)',
            width: 160,
            dataIndex: 'ename',
            // editable: true,
            editable:editFormVal.status !== 'shipment.bl',
        }, {
            title: '费用类型',
            width: 160,
            dataIndex: 'name',
            // editable: true,
            editable:editFormVal.status !== 'shipment.bl',
        }, {
            title: '总金额',
            width: 160,
            dataIndex: 'amount',
            // editable: true,
            editable:editFormVal.status !== 'shipment.bl',
            render: (text: any) => text === "null" ? "" : `${getcurrencySymbol(mode)}${formatNum(text)}`,
        }, {
            title: '状态',
            width: 160,
            dataIndex: 'status',
            render: (text: string) => getTreeNodeName(text)
        }, {
            title: '附件',
            width: 160,
            dataIndex: 'filename',
            render: (text: string, record: IShipmentDetailsAdded) => {
                if (!text) return "";
                let fileNameArr = text.split("%^&") ?? [];
                let fileMd5Arr = record.md5?.split(",") ?? [];
                return fileMd5Arr.map((item, index) => {
                    if ((item.indexOf(".png") > -1 || item.indexOf(".jpg") > -1 || item.indexOf(".gif") > -1)) {
                        return <div key={index}>
                            <Image src={`${getBaseRequestUrl()}/fsrv/fetch/${item}?Authorization=${getToken()}`} style={{ width: "40px", height: "40px", marginRight: "10px" }} />
                            <span style={{ color: "blue" }} onClick={() => downloadFile(item, fileNameArr[index] ?? item)}>{fileNameArr[index] ?? item}</span>
                        </div>
                    } else {
                        return <div key={index} style={{ color: "blue" }} onClick={() => downloadFile(item, fileNameArr[index] ?? item)}>{fileNameArr[index] ?? item}</div>
                    }
                })

            }
        }
    ];

    const newColumns = columns.map((col: any, index) => {
        return {
            ...col,
            onCell: (record: IShipmentDetailsAdded, rowIndex: number) => ({
                colIndex: index + 1,
                rowIndex,
                record,
                rules: col.rules,
                options: col.options,
                editType: col.editType,
                //最后一行合计不可以编辑,  已结算的不可编辑
                editable: record.key === "totalAmount" ? false : record.status === DictCodeEnmu.SHIPMENT_SETTLE ? false : col?.editable,
                dataIndex: col.dataIndex,
                title: col.title,
                handleSave: handleSave,
            }),
        }
    })

    //内联编辑
    const handleSave = (row: IShipmentDetailsAdded) => {
        row.amount = formatNum(row.amount);
        if (row.supplierCode) {
            row.supplierName = supplierDs.find(item => item.value === row.supplierCode)?.label;
        }
        let dataSource = [...editAddedList];
        const index = dataSource.findIndex((item) => row.key === item.key);
        const item = dataSource[index];
        dataSource.splice(index, 1, { ...item, ...row });
        setEditAddedList(dataSource);

        //金额变动后，  修改主单的附加费 及 重新计算合同金额
        if (row.amount !== item.amount) {
            updateFormVal({
                // contractAmount: clauseChange(dataSource),
                addAmount: dataSource.reduce((con, next) => { con = con + +(next?.amount ?? 0); return con }, 0)
            });
        }
        setIsSave(false)
    }

    const totalRow = {
        key: "totalAmount",
        totalTxt: "合计:",
        amount: editAddedList.reduce((con, next) => { con = con + +(next?.amount ?? 0); return con }, 0)
    }

    const upLoadCallback = async (file: File & { response: { retData: string } }) => {
        if (file) {
            let dataSource = [...editAddedList];
            const index = dataSource.findIndex((item) => item.key === selectedRowKeys[0]?.key);
            const item = dataSource[index];
            dataSource.splice(index, 1, {
                ...item,
                filename: item.filename ? item.filename + "%^&" + file.name : file.name,
                md5: item.md5 ? item.md5 + "," + file?.response.retData : file?.response.retData
            });
            setEditAddedList(dataSource);
            setIsSave(false)
        }
    }
    const action = <>
        <Upload
            showUploadList={false}
            className="mr-10 ml-10"
            beforeUpload={() => {
                if (selectedRowKeys.length !== 1) {
                    message.warning("请选择单条数据后进行文件上传");
                    return false;
                }
                return true;
            }}
            {...importPropsConfig(`00`, upLoadCallback)}
        >
            <Button className="mr-5" type="link" shape="round">导入</Button>
        </Upload>
        <YhAuth resCode={ResourceAuthEnum.SH_ED_SETTLE}>
            <Button
                className="mr-5"
                type="link"
                shape="round"
                disabled={!isSave}
                onClick={() => {
                    if (selectedRowKeys.length !== 1) {
                        message.warning("请选择单条数据进行结算");
                        return false;
                    }
                    if (!selectedRowKeys[0].id) {
                        message.warning("请保存后进行结算");
                        return false;
                    }
                    //拿到实时变动的
                    let newRow = editAddedList.find(item => item.key === selectedRowKeys[0].key) as IShipmentDetailsAdded;
                    if (+(newRow.amount) <= 0) {
                        message.warning("金额不可小于0");
                        return false;
                    }
                    // if (newRow.status !== DictCodeEnmu.SHIPMENT_PEND_SETTLE && newRow.supplierCode) {
                    //     message.warning("请选择供应商后，状态为【待结算】的单据进行结算");
                    //     return false;
                    // }
                    if (newRow.status !== DictCodeEnmu.SHIPMENT_PEND_SETTLE) {
                        message.warning("此单据已进行过结算");
                    }
                    setSettleVisible({
                        visible: true,
                        addedRow: newRow
                    })
                }}
            >结算</Button>
        </YhAuth>
    </>

    return (
        <YhBox title="加收费用" style={{ marginBottom: "10px", width: "100%" }} rightChildren={action}>
            <Table
                rowClassName='editable-row yh-edit-table-tr'
                rowSelection={{
                    selectedRowKeys: selectedRowKeys.map(item => item.key), //记录选中
                    onChange: (selectedRowKeys: React.Key[], selectedRows: IShipmentDetailsAdded[]) => {
                        setSelectedRowKeys(selectedRows.filter(item => item.key !== "totalAmount") as IShipmentDetailsAdded[]);
                    }
                }}
                components={{
                    body: {
                        row: EditableRow,
                        cell: EditableCell,
                    },
                }}
                columns={newColumns as ColumnsType<IShipmentDetailsAdded>}
                dataSource={editAddedList.length > 0 ? [...editAddedList, totalRow] : []}
                pagination={false}
                scroll={{ x: 'max-content', y: 200 }}
            />
        </YhBox>
    )
}